module.exports = __webpack_public_path__ + "static/37gde-7162402a19bc1daba68fa591304b02f0.gif";